<div>
  <div class="contact-home" [ngClass]="{'contact-home-acmic':isAcmic}">
    <div class="section-title">
      <div class="contact-title-font" [ngClass]="{ 'mapfre-blue-secondary dm-sans-medium': !isAcmic }">
        {{ "MANAGE_CONTACT_DETAILS" | translate }}
      </div>
    </div>
    <section class="">
      <mapfre-alert [closeButton]="true" [notTop]="false"></mapfre-alert>
    </section>
    <div class="contact-details">
      <div class="contact-wrapper">
        <div class="contact-block email-block-border" *ngIf="email">
          <div class="contact-title mt-4 margin-bottom mb8" >{{ "Email" | translate }}</div>
          <div class="emails-list">
            <ng-container *ngIf="existGWPolicy || existAS400Policy; else legacyEmailInfo">
              <div class="logged-email-text">
                {{ "EMAIL_FOR_MFA" | translate }}
              </div>
            </ng-container>
            <ng-template #legacyEmailInfo>
              <div class="logged-email-text">
                {{ "THIS_EMAIL_IS_USED_TO_LOG_IN" | translate }}
              </div>
            </ng-template>
            <div class="email-edit-sec">
              <div class="logged-email " [ngClass]="{ 'dm-sans-medium': !isAcmic}">{{ email }}</div>
              <div class="edit-button">
                <mapfre-button
                  (click)="gotoEditContact()"
                  additionalClasses="x-small-btn"                  
                >
                  {{ "EDIT_CONTACT" | translate }}
                </mapfre-button>
              </div>
            </div>
          </div>
        </div>
        <div class="contact-block phone-block" *ngIf="existGWPolicy" [ngClass]="{'contact-block-nophone':listOfPhones === 0 ,'otherPhonesAcmic':otherPhones?.length > 0 && isAcmic}">
          <div class="contact-title phone-num-64" [ngClass]="{ 'mapfre-blue-secondary': !isAcmic }">
            {{ "Phone numbers" | translate }}
          </div>
          <div class="emails-list">
            <div
              class="items-list primary-block"
              [ngClass]="{ 'empty-phone': listOfPhones === 0 }"
            >
              <ng-container *ngIf="listOfPhones === 0; else hasPhone">
                <div class="item-title item-title-nophone">
                  <div class="description">
                    <div>
                      {{ "NO_PHONE" | translate }}
                    </div>
                  </div>
                  <div class="item-action item-action-nophone">
                    <div class="edit-button add-phone-btn-no-phone">
                      <mapfre-button (click)="gotoEditContact()" additionalClasses="x-small-btn">
                        {{ "ADD_PHONE" | translate }}
                      </mapfre-button>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #hasPhone>
                <ng-container *ngIf="primaryPhone?.number">
                  <div class="item-title">
                    <div class="description">
                      <div class="primary-phone">
                        {{ "PRIMARY_PHONE" | translate }}
                      </div>
                      <div class="margin-bottom mb8">
                        {{ "THIS_IS_CONSIDERED_THE_BEST" | translate }}
                      </div>
                    </div>
                  </div>
                  <div class="item-action">
                    <div class="value-contnet">
                      <span class="phone-type">{{ primaryPhone?.type }}</span>
                      <span>{{ primaryPhone?.number }}</span>
                    </div>
                    <div class="edit-button">
                      <mapfre-button
                        (click)="gotoEditContact()"
                        additionalClasses="x-small-btn"                        
                      >
                        {{ "EDIT_CONTACT" | translate }}
                      </mapfre-button>
                    </div>
                  </div>
                </ng-container>
              </ng-template>
            </div>
            <div [ngClass]="{'padding-top pt32':!existGWPolicy}" class="other-phones" *ngIf="otherPhones?.length > 0">
              <ng-container *ngIf="!existGWPolicy">
                <div class="other-phones-text">
                  {{ "OTHER_PHONES" | translate }}
                </div>
              </ng-container>
              <div class="items-list" *ngFor="let otherPhone of otherPhones" [ngClass]="{'remove-border':otherPhonesLength===2}">
                <div class="item-title">
                  <div class="value-contnet">
                    <div class="on-mobile" *ngIf="!isAcmic">
                      <div class="primary-phone margin-bottom mb8 ">
                        <span style="text-transform: capitalize;">{{ otherPhone?.type }}</span> phone
                      </div>
                        <span class="phone-type">
                        Mobile
                      </span>
                      <span>
                        {{ otherPhone?.number }}
                      </span>
                    </div>
                    <div [ngClass]="{'on-desktop':!isAcmic}">
                      <span class="phone-type">
                        {{ otherPhone?.type }}
                      </span>
                      <span>
                        {{ otherPhone?.number }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="item-action">
                  <div class="edit-button">
                    <mapfre-button
                      (click)="gotoEditContact()"
                      additionalClasses="x-small-btn"                      
                    >
                      {{ "EDIT_CONTACT" | translate }}
                    </mapfre-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="add-phone" *ngIf="listOfPhones < 3 && listOfPhones !== 0" [ngClass]="{'add-phone-border':!existGWPolicy}">
              
                <ng-container *ngIf="existGWPolicy ; else legacyPolicy">
                  <div class="new-phone-number" (click)="gotoEditContact()">Add new phone number</div>
                </ng-container>
                <ng-template #legacyPolicy>
                  <div class="item-action">
                    <div class="edit-button">
                      <mapfre-button (click)="gotoEditContact()" additionalClasses="x-small-btn">
                        {{ "ADD_PHONE" | translate }}
                      </mapfre-button>
                    </div>
                  </div>
                </ng-template>
                
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-top mt24 text-center checkingrowbtm">
      <div class="col ">
        <ng-container *ngIf="!isAcmic else acmicBackBtn">
          <mapfre-button additionalClasses="link-button back-btn small red-link no-margin button-border-red "
            [backIcon]="'./assets/img/icons/back-arrow-red.png'" [iconClasses]="'align-middle'" [showIconsCustom]="true"
            [routerLink]="['/profile']">
            {{ "BACK" | translate }}
          </mapfre-button>
        </ng-container>
        <ng-template #acmicBackBtn>
          <div [routerLink]="['/profile']" class="acmic-back-btn">
            <img src="assets/img/images/okta-acmic-arrow-left.svg" alt="back btn">
            {{ "BACK" | translate }}
          </div>
        </ng-template>
      </div>
    </div>
      <div class="contact-disclosure-block">
        {{ "CONTACT_USE_DISCLOSURE_TITLE" | translate }}
        <div class="disclosure-text">
          {{ "CONTACT_USE_DISCLOSURE_TEXT" | translate }}
        </div>        
      </div>
  </div>
</div>
